import { useContext } from 'react';
import { ModalContext } from '../../providers/ModalProvider';

export default function useModal() {
  const { modal, show, remove} = useContext(ModalContext);
  return { modal, show, remove };
}